import { createContext, useState, ReactNode } from "react";
import type { BookmarkData } from "../types/narrative";

interface BookmarkState {
  [groupId: string]: BookmarkData | null;
}

export interface BookmarkContextType {
  bookmarks: BookmarkState;
  setBookmark: (groupId: string, data: BookmarkData | null) => void;
  clearAllBookmarks: () => void;
  isBookmarked: (groupId: string) => boolean;
}

const BookmarkContext = createContext<BookmarkContextType | undefined>(
  undefined,
);

export { BookmarkContext };

export function BookmarkProvider({ children }: { children: ReactNode }) {
  const [bookmarks, setBookmarks] = useState<BookmarkState>({});

  const setBookmark = (groupId: string, data: BookmarkData | null) => {
    setBookmarks((prev) => {
      const next = { ...prev };
      if (data === null) {
        delete next[groupId];
      } else {
        next[groupId] = data;
      }
      return next;
    });
  };

  const clearAllBookmarks = () => {
    setBookmarks({});
  };

  const isBookmarked = (groupId: string) => {
    return bookmarks[groupId] !== undefined && bookmarks[groupId] !== null;
  };

  return (
    <BookmarkContext.Provider
      value={{
        bookmarks,
        setBookmark,
        clearAllBookmarks,
        isBookmarked,
      }}
    >
      {children}
    </BookmarkContext.Provider>
  );
}
